import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
// Bootstrap vu CSS
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import App from './app/app'
import router from './app/router/router'
import './styles/main.scss'
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
import VueBootstrapToasts from 'vue-bootstrap-toasts'
import VueSimpleContextMenu from 'vue-simple-context-menu'
import Toasted from 'vue-toasted'
// import * as Sentry from '@sentry/browser'
// import * as Integrations from '@sentry/integrations'
import './sentry.js'
import moment from 'moment'
import { BSpinner } from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import store from './store'
import '@/permission'
import { Auth } from '@/core/utils/auth'
import LoadScript from 'vue-plugin-load-script'

import 'vue-search-select/dist/VueSearchSelect.css'

// simple context menu CSS
import 'vue-simple-context-menu/dist/vue-simple-context-menu.css'


require('lodash')

// Sentry.init({
//   dsn: 'https://b30c07847f034d09be6e3cb402c8a9d8@sentry.aiotools.ovh/10',
//   integrations: [
//     new Integrations.Vue({
//       Vue,
//       attachProps: true
//     })
//   ]
// })

Vue.config.productionTip = process.env.NODE_ENV === 'production'

Vue.use(LoadScript)
Vue.use(BootstrapVue)
Vue.use(VueBootstrapToasts)
Vue.use(Toasted, {
                    theme: "bubble",
                    position: "top-right",
                    duration : 5000
                  })
Vue.use(require('vue-moment'))
Vue.component('vue-bootstrap-typeahead', VueBootstrapTypeahead)
Vue.component('b-spinner', BSpinner)
Vue.component('vue-simple-context-menu', VueSimpleContextMenu)
Vue.component('apexchart', VueApexCharts)

store.dispatch('Initialize')

Vue.directive('uppercase', {
   bind(el, _, vnode) {
     el.addEventListener('keyup', (e) => {
         e.target.value = e.target.value.toUpperCase()
         vnode.componentInstance.$emit('input', e.target.value.toUpperCase())
     })
   }
})

Vue.mixin({
  data () {
    return {
      alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
    }
  },
  methods: {
    goTo: function (path) {
      this.$router.push(path)
    },
    padStrg (num, size) {
      let s = num.toString() + ''
      while (s.length < size) {
        s = '0' + s
      }
      return s
    },
    isUserThales () {
      return Auth.getUserRole().includes('thales')
    },
    isUserAdmin () {
      return Auth.getUserRole().includes('admin')
    },
    isUserThalesAdmin () {
      return Auth.getUserRole().includes('thales') && Auth.getUserRole().includes('admin')
    },
    readOnlyThales () {
      return Auth.getUserRole().includes('guests')
    },
    // dont call callback if context is destroyed
    setProtectedTimeout(callback, timeoutInSec ) {
      if (this._isDestroyed ) {
        return null
      } else {
        return setTimeout(callback, timeoutInSec)
      }
    },
    timeArray: function (time) {
      var day
      var hour
      var min
      var sec
      time = (new Date(time)).getTime() / 1000
      time = Math.floor(time)
      sec = time % 60
      sec = ('0' + sec).slice(-2)

      time = Math.floor((time - sec) / 60)
      min = time % 60
      min = ('0' + min).slice(-2)

      time = Math.floor((time - min) / 60)
      hour = time % 24
      hour = ('0' + hour).slice(-2)

      time = Math.floor((time - hour) / 24)
      day = ('0' + time).slice(-2)

      return { sec, min, hour, day }
    },
    timeDisplay: function (time) {
      var currentDate = new Date(time)
      return currentDate.toLocaleDateString() + ' à ' + currentDate.toLocaleTimeString()
    },
    displayDate (date) {
      return moment(date).format('DD/MM/YYYY')
    },
    containsWarning: function (items) {
      if (items === undefined) { return false }
      for (let item = 0; item < items.length; ++item) {
        if (items[item].state == 'fast' && items[item].proceed_at == null) {
          return true
        }
      }
      return false
    },
    containsSlow: function (items) {
      if (items === undefined) { return false }
      for (let item = 0; item < items.length; ++item) {
        if (items[item].state.toLowerCase() == 'slow' && items[item].proceed_at == null) {
          return true
        }
      }
      return false
    },
    sec2min: function (sec) {
      return Math.round(sec / 60.0)
    },
    timeAndon: function (start_at) {
      var now = new Date()
      // Adding two hours to start_at because of the timezone
      var tmp = Date.parse(now) - (Date.parse(start_at))
      var diff = this.dateDiff(tmp)
      var time = diff.day * 24 * 60 + diff.hour * 60 + diff.min

      var start_iso = new Date(start_at).toISOString()
      var start = new Date(start_iso)

      // subtract night hours and week-end
      if (diff.day > 0) {
        if ((start.getDay() >= 4) && (now.getDay() == 0)) {
          time -= 2 * (24 * 60)
          time -= (14.5 * 60) * (diff.day - 2)
        } else {
          time -= (14.5 * 60) * diff.day
        }
      }
      // subtract midday hours
      if ((start.getHours() > 12) && ((now.getHours() < 14) && (now.getMinutes() < 20))) {
        if (diff.day > 0) {
          if ((start.getDay() >= 4) && (now.getDay() == 0)) {
            time -= 1.5 * 60 * diff.day - 2
          }
        } else {
          time -= 1.5 * 60
        }
      }
      return time
    },
    makeToast(text, append = false) {
      let toast = this.$toasted.success(text, {
         theme: "bubble",
         position: "top-right",
         duration : 5000
      });
    },
    chunk(str, n) {
      let ret = [];
      let i;
      let len;

      for(i = 0, len = str.length; i < len; i += n) {
          ret.push(str.substr(i, n))
      }
      return ret.join(' ')
    },
    dateDiff: function (tmp) {
      var diff = {}
      // Nombre de secondes entre les 2 dates
      tmp = Math.floor(tmp / 1000)
      diff.sec = tmp % 60
      // Nombre de minutes (partie entière)
      tmp = Math.floor((tmp - diff.sec) / 60)
      diff.min = tmp % 60
      // Nombre d'heures (entières)
      tmp = Math.floor((tmp - diff.min) / 60)
      diff.hour = tmp % 24
      // Nombre de jours restants
      tmp = Math.floor((tmp - diff.hour) / 24)
      diff.day = tmp
      return diff
    }
  }
})

// eslint-disable-next-line
Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('YYYY/MM/DD')
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App),
  methods: {
    isAuthStillLogged () {
      let payload = store.getters.getPayload
      let checkInXmilliSec = 1000 * 60 * 10
      if (_.isEmpty(payload) || isNaN(payload.exp) || payload.exp <= 0) {
      } else {
        checkInXmilliSec = ((payload.exp - 60) * 1000) - moment().valueOf()
        console.log(`> Timer: Recheck in ${checkInXmilliSec} ms.`)
      }
      setTimeout(function () {
        Auth.goLogin()
      }.bind(this), checkInXmilliSec)
    },
  },
  mounted () {
    this.isAuthStillLogged()
  }
})



// WEBPACK FOOTER //
// ./src/main.js